<template>
    <div class="product-warp">
        <div class="product-banner">
            <img src="../../assets/images/banner2.jpg" alt="">
        </div>

        <!-- 核心产品内容 -->
        <div class="product-main">
            <div class="prc-content">

                <!-- 左侧内容 -->
                <div class="prc_updown">
                    <p class="title_li">核心产品</p>
                    <ul>
                        <li id="tab-list" class="active-list">视频智能处理器</li>
                        <li id="tab-list">视频实时压缩服务器</li>
                        <li id="tab-list">历史视频压缩服务器</li>
                        <li id="tab-list">视频转码服务器</li>
                        <li id="tab-list">VDMS系统管理服务器</li>
                        <li id="tab-list">MT视频压缩处理器-184</li>
                        <li id="tab-list">MT视频压缩处理器-512</li>
                    </ul>
                </div>
                
                <!-- 右侧内容 -->
                <div class="prc_cards">
                    <!-- 1.视频智能处理器 -->
                    <div id="right_alllist">
                        <div class="product-img"> <img src="../../assets/images/107.png" alt=""> </div>
                        <div class="liness">VDMS-T-1</div>
                        <div class="pro-countent">
                            <div class="product-title">产品简述</div>
                            <p style="margin-bottom: 40px;">本产品与前端摄像机为1比1实时压缩，通过先进的机器视觉、人工智能检索等技术，在不改变视频原有的帧率、分辨率、时长的情况下进行实时压缩，即减少了后端存储的压力又保证了视频的完整传输。</p>
                            <div class="product-title">特点优势</div>
                            <ul>
                                <li><span></span>独有VDMS压缩算法，更大程度上实现高清晰的图像传输，节省90%带宽和存储空间。</li>
                                <li><span></span>支持D5（1080P）高清晰编码，兼容D4（720P）、D3（1080i）、Half-D1、CIF、QCIF格式。先进的网络转发服务器技术，轻松实现多用户访问，支持用户密码权限管理。</li>
                                <li><span></span>内置Web Server，通过IE浏览器轻松实现远程监看、设置等操作。</li>
                                <li><span></span>支持设备远程安全升级功能。</li>
                                <li><span></span>支持本地存储SD卡接口。</li>
                                <li><span></span>支持802.11b/g WiFi无线网络，支持4G、3G、CDMA、GPRS移动网络。</li>
                                <li><span></span>支持局域网、广域网传输。</li>
                                <li><span></span>网络自适应技术，根据网络带宽自动调整视频清晰度。</li>
                                <li><span></span>支持高清视频文件实时保存，文件云备份，文件断点续传。</li>
                                <li><span></span>支持监测摄像头的状况（遮挡，掉线，视频质量等），支持对摄像头进行重启。</li>
                                <li><span></span>支持GB28181、ONVIF 协议，支持透明协议。</li>
                                <li><span></span>异常自动恢复功能，网络中断自动重连功能。</li>
                            </ul>
                            <div class="product-title" style="margin-top: 60px;">适用场景</div>
                            <p>主要适用于传输带宽不足、异地互联网传输、临时性网络传输、传输带宽不足、传输距离过远、存储空间不足及扩容等。</p>
                            <p style="text-indent: 2em;">例如：（建筑工地、偏远山区、国内外传输、卫星传输等场景）。</p>
                            <div class="product-title" style="margin-top: 45px;">产品型号</div>
                            <div>
                                <table width="903px" height="343px" border="0" cellpadding="0" cellspacing="0" class="table-pro">
                                    <tr>
                                        <td></td>
                                        <td>产品型号</td>
                                        <td>性能</td>
                                        <td width="10%">参数</td>
                                    </tr>
                                    <tr>
                                       <td></td>
                                       <td>VDMS-T-1-B</td>
                                       <td>单路1080P视频实时流压缩</td>
                                       <td style="border: none"></td>
                                       
                                    </tr>
                                    <tr>
                                       <td>VDMS-T-1系列</td>
                                       <td> VDMS-T-1-B套餐一</td>
                                       <td>单路1080P视频实时流压缩+4G传输模块</td>
                                       <td class="table-joup" @click="modal10 = true">查看</td>
                                    </tr>
                                    
                                    <tr>
                                       <td></td>
                                       <td> VDMS-T-1-B套餐二</td>
                                       <td>单路1080P视频实时流压缩+SD卡（128G），本地可存30天</td>
                                       <td style="border: none"></td>
                                    </tr>
                                    <tr>
                                       <td></td>
                                       <td> VDMS-T-1-B套餐三</td>
                                       <td>单路1080P视频实时流压缩+4G传输模块+ SD卡（128G）</td>
                                       <td style="border: none"></td>
                                    </tr>
                                </table> 
                            </div>
                        </div>
                    </div>
                    <!-- 第一个弹出框 -->
                    <Modal
                        title="产品参数"
                        v-model="modal10"
                        class-name="vertical-center-modal"
                        width="1053"
                        >
                        <table width="963px" border="0" cellpadding="0" cellspacing="0" class="table-modal">
                            <tr>
                                <td width="20%">产品名称</td>
                                <td width="80%">视频智能处理器</td>
                            </tr>
                            <tr>
                               <td>产品型号</td>
                               <td>VDMS-T系列</td>
                            </tr>
                            <tr>
                               <td>处理器型号</td>
                               <td>双ARM 处理器</td>
                            </tr>
                            <tr>
                               <td>存储接口</td>
                               <td>支持SD卡存储和图像抓拍，SD3.0标准，最大支持128G卡</td>
                            </tr>
                            <tr>
                               <td>输入电源</td>
                               <td>直流12V 1A</td>
                            </tr>
                            <tr>
                                <td>功率</td>
                                <td>8W</td>
                            </tr>
                            <tr>
                                <td>工作温度</td>
                                <td>-10℃~+65℃</td>
                            </tr>
                            <tr>
                                <td>工作湿度</td>
                                <td>10 ~ 85%</td>
                            </tr>
                            <tr>
                                <td>海拔</td>
                                <td>适用于2000米及以下地区安全使用</td>
                            </tr>
                            <tr>
                                <td>气候</td>
                                <td>适用于非热带气候条件安全使用</td>
                            </tr>
                            <tr>
                                <td>处理能力</td>
                                <td>1路网络摄像机视频输入，1路视频输出</td>
                            </tr>
                            <tr>
                                <td>压缩倍率</td>
                                <td>90%</td>
                            </tr>
                            <tr>
                                <td>支持格式</td>
                                <td>
                                    视频输入 H.264，
                                    视频输出H.264、H.265、bbw
                                </td>
                            </tr>
                            <tr>
                                <td>网络协议</td>
                                <td>HTTP, TCP/IP, UDP , DNS, SNTP, DHCP, FTP, SNMP，NTP，UPNP。</td>
                            </tr>
                            <tr>
                                <td>视频帧率</td>
                                <td>1 - 25帧/秒可选</td>
                            </tr>
                            <tr>
                                <td>外部接口</td>                
                                <td>
                                    2个USB接口，
                                    1个复位开关，
                                    2个RJ45网络接口，
                                    1个同轴天线接口，
                                </td>
                            </tr>
                            <tr>
                                <td>支持网络</td>
                                <td>
                                    支持802.11b/g WiFi无线网络
                                    支持802.11b/g WiFi无线网络，
                                    支持4G、3G、CDMA、GPRS移动网络
                                </td>
                            </tr>
                            <tr>
                                <td>外型类型</td>
                                <td>嵌入式</td>
                            </tr>
                            <tr>
                                <td>产品尺寸</td>
                                <td>133mm(L) *80mm(W)* 24mm(H)</td>
                            </tr>
                            <tr>
                                <td>产品重量</td>
                                <td>0.2Kg</td>
                            </tr>
                            
                        </table> 
                    </Modal>

                    <!-- 2.视频实时压缩服务器 -->
                    <div id="right_alllist" class="hide">
                        <div class="product-imges"> 
                            <img src="../../assets/images/108.png" alt=""> 
                            <img src="../../assets/images/81.png" alt="">
                        </div>
                        <div class="lines">视频实时压缩服务器</div>
                        <div class="pro-countent">
                            <div class="product-title">产品简述</div>
                            <p>司马大大以安防为基点，以视频大数据深度应用为目标，融合多种AI算法和十余项创新科技的应用，在编解码过程中，形成独特的编解码方案，在不改变清晰度、不改变帧率、不损失特征点的前提下，实现了高清视频10倍以上的实时无损压缩编解码技术，降低了视频传输和存储的压力，解决了视频结构化存储与有效管理的难题。在此基础上，司马大大还进行了视频智能应用的探索。目前，在行为分析、客流统计、车牌识别、人脸识别、移动目标分析等诸多方面均有实质性突破与项目合作。</p>
                            <p style="margin-bottom: 40px;">公司自主研发的视频压缩服务器，能在保持原有视频清晰度的同时，将原有视频体量压缩1/10-1/30，促使码流增速达90%以上，大幅降低了视频存储的管理成本，提高了数据处理和使用的效率。此项技术可在不改变硬件存储容量的基础上，通过扩容服务器的算法，将原来的高清视频存储量提升十倍以上，填补了视频数据智能化管理产业链的空白。同时，底层自有的编解码技术能够保证信息安全，体现自主可控。</p>
                            <div class="product-title">特点优势</div>
                            <ul>
                                <li><span></span>高效存储：VDMS系统能够在不影响原有视频画质，不改变原有视频帧率、时长的前提下对视频数据进行压缩存储管理，平均可以节省10倍以上的存储空间，大幅降低存储要求和成本</li>
                                <li><span></span>支持多种存储架构：VDMS支持存储服务器存储等分布式存储架构和IP-SAN、FC-SAN、云存储等集中存储架构</li>
                                <li><span></span>存储方案灵活：存储方案可采用系统默认分段存储方案，也可根据实际情况对存储效率和存储周期进行调节</li>
                                <li><span></span>视频格式加密：VDMS独特的bbw文件格式，大幅提高数据的安全性和保密性</li>
                                <li><span></span>满足图像客观评价标准：经VDMS处理完后的视频图像峰值信噪比PSNR值不低于32dB，保证视频清晰度</li>
                                <li><span></span>符合安全规范标准：VDMS符合GB/T28181规范等国家标准和行业标准，支持主流的视频和流媒体格式</li>
                            </ul>
                            <div class="product-title" style="margin-top: 60px;">适用场景</div>
                            <p>主要适用于将所有视频数据集中存储到一个或几个数据中心，数据存储量打，存储时间长，前端摄像头多，存储建设成本高等场景。</p>
                            <p style="text-indent: 2em;">例如：雪亮工程、平安城市等。</p>
                            <div class="product-title" style="margin-top: 45px;">产品型号</div>
                            <div>
                                <table width="903px" height="343px" border="0" cellpadding="0" cellspacing="0" class="table-pro">
                                    <tr>
                                        <td width="15%"></td>
                                        <td width="20%" height="60px">产品型号</td>
                                        <td width="50%">性能</td>
                                        <td width="10%">参数</td>
                                    </tr>
                                    <tr>
                                       <td></td>
                                       <td>VDMS-CA-12/25HB</td>
                                       <td>塔式，可同时处理12路1080P视频或者25路720P视频实时流压缩（不含存储盘）</td>
                                       <td class="table-joups" @click="modal1 = true">查看</td>
                                       
                                    </tr>
                                    <tr>
                                       <td>视频实时压缩服务器</td>
                                       <td>VDMS-CAS-25/50HB</td>
                                       <td>机架式(双电/2U)，可同时处理25路1080P视频压缩或者50路720P视频压缩，或者25路1080P视频实时转码（*bbw转通用格式）（不含存储盘）</td>
                                       <td class="table-joups" @click="modal2 = true">查看</td>
                                    </tr>
                                    
                                    <tr>
                                       <td></td>
                                       <td>VDMS-CAS-50/100HB</td>
                                       <td>机架式(双电/2U)，可同时处理50路1080P视频压缩或者100路720P视频压缩，或者50路1080P视频实时转码（*bbw转通用格式）（不含存储盘）</td>
                                       <td class="table-joups" @click="modal3 = true">查看</td>
                                    </tr>
                                    <tr>
                                       <td></td>
                                       <td> VDMS-CAS-75/150HB</td>
                                       <td>机架式(双电/2U)，可同时处理75路1080P视频压缩或者150路720P视频压缩（不含存储盘）</td>
                                       <td class="table-joups" @click="modal4 = true">查看</td>
                                    </tr>
                                </table> 
                            </div>
                        </div>
                    </div>
                    <!-- 视频实时压缩服务器  第一个弹出框 -->
                    <Modal
                        title="产品参数"
                        v-model="modal1"
                        class-name="vertical-center-modal"
                        width="1053"
                        >
                        <table width="963px" border="0" cellpadding="0" cellspacing="0" class="table-modal">
                            <tr>
                                <td width="20%">产品名称</td>
                                <td width="80%">视频实时压缩服务器</td>
                            </tr>
                            <tr>
                               <td>产品型号</td>
                               <td>VDMS-CA-12/25HB</td>
                            </tr>
                            <tr>
                               <td>外型</td>
                               <td>塔式</td>
                            </tr>
                            <tr>
                               <td>处理器</td>
                               <td>I7 6700K</td>
                            </tr>
                            <tr>
                               <td>GPU型号</td>
                               <td>P2000</td>
                            </tr>
                            <tr>
                               <td>内存</td>
                               <td>16GB</td>
                            </tr>
                            <tr>
                                <td>RAID</td>
                                <td>支持RAID 0,1,5,10</td>
                            </tr>
                            <tr>
                                <td>存储</td>
                                <td>标配1块*3.5英寸1T 7200 rpm SATA硬盘
                                    最大可扩展到2块SAta硬盘，支持2T/4T/6T/8T硬盘</td>
                            </tr>
                            <tr>
                                <td>集成I/O端口</td>
                                <td>2个千兆网络接口</td>
                            </tr>
                            <tr>
                                <td>其他</td>
                                <td>支持DP高清视频接口，配备BMI板卡</td>
                            </tr>
                            <tr>
                                <td>电源</td>
                                <td>额定功率：450W</td>
                            </tr>
                            <tr>
                                <td>显示控制器</td>
                                <td>主板集成显示控制器+独立显卡控制器</td>
                            </tr>
                            <tr>
                                <td>性能</td>
                                <td>25路（720P）/12路（1080P）视频压缩</td>
                            </tr>
                            <tr>
                                <td>输入视频格式</td>
                                <td>
                                    H.264、H.265、MPEG1/2、MPEG4、RM/RMVB、WMV、DIVX等主流视频格式
                                </td>
                            </tr>
                            <tr>
                                <td>输出视频格式</td>
                                <td>bbw</td>
                            </tr>
                            <tr>
                                <td>传输协议</td>
                                <td>ONVIF、GB/T28181、私有SDK等协议</td>
                            </tr>
                            <tr>
                                <td>工作环境温度</td>                
                                <td>0℃～45℃</td>
                            </tr>
                            <tr>
                                <td>交流输入</td>
                                <td>220V，50Hz</td>
                            </tr>
                            <tr>
                                <td>机箱尺寸</td>
                                <td>208MM (W) x 270MM (D) x 372MM (H)</td>
                            </tr>
                            <tr>
                                <td>满配重量</td>
                                <td>13.8Kg</td>
                            </tr>
                            
                        </table> 
                    </Modal>
                    <!-- 第二个弹出框 -->
                    <Modal
                        title="产品参数"
                        v-model="modal2"
                        class-name="vertical-center-modal"
                        width="1053"
                        >
                        <table width="963px" border="0" cellpadding="0" cellspacing="0" class="table-modal">
                            <tr>
                                <td width="20%">产品名称</td>
                                <td width="80%">视频实时压缩服务器</td>
                            </tr>
                            <tr>
                               <td>产品型号</td>
                               <td>VDMS-CAS-25/50HB</td>
                            </tr>
                            <tr>
                               <td>外型</td>
                               <td>机架式2U</td>
                            </tr>
                            <tr>
                               <td>处理器</td>
                               <td>E5-2620V4</td>
                            </tr>
                            <tr>
                               <td>GPU型号</td>
                               <td>P2000*2</td>
                            </tr>
                            <tr>
                               <td>内存</td>
                               <td>16GB</td>
                            </tr>
                            <tr>
                                <td>RAID</td>
                                <td>支持RAID 0,1,5,10</td>
                            </tr>
                            <tr>
                                <td>存储</td>
                                <td>标配1块*3.5英寸1T 7200 rpm SAS硬盘
                                    最大可扩展到8块SAS硬盘，支持2T/4T/6T/8T硬盘</td>
                            </tr>
                            <tr>
                                <td>I/O扩展槽</td>
                                <td>Risers 含最高 3x8 PCIe 插槽 + 1x16 PCIe 插槽</td>
                            </tr>
                            <tr>
                                <td>集成I/O端口</td>
                                <td>前置：2个USB接口，1个标准VGA接口
                                    后置：1个标准VGA接口，1个千兆管理网口
                                     4个千兆网络接口，2个USB接口</td>
                            </tr>
                            <tr>
                                <td>其他</td>
                                <td>支持DP高清视频接口，配备BMI板卡</td>
                            </tr>
                            <tr>
                                <td>电源</td>
                                <td>额定功率：750W（双电）</td>
                            </tr>
                            <tr>
                                <td>显示控制器</td>
                                <td>主板集成显示控制器+独立显卡控制器</td>
                            </tr>
                            <tr>
                                <td>性能</td>
                                <td>50路（720P）/25路（1080P）视频压缩</td>
                            </tr>
                            <tr>
                                <td>输入视频格式</td>
                                <td>
                                   H.264、H.265、MPEG1/2、MPEG4、RM/RMVB、WMV、DIVX等主流视频格式
                                </td>
                            </tr>
                            <tr>
                                <td>输出视频格式</td>
                                <td>bbw</td>
                            </tr>
                            <tr>
                                <td>传输协议</td>
                                <td>ONVIF、GB/T28181、私有SDK等协议</td>
                            </tr>
                            <tr>
                                <td>工作环境温度</td>                
                                <td>0℃～45℃</td>
                            </tr>
                            <tr>
                                <td>交流输入</td>
                                <td>220V，50Hz</td>
                            </tr>
                            <tr>
                                <td>机箱尺寸</td>
                                <td>87.3mm(高)*444.0mm(宽)*684.0mm(深)</td>
                            </tr>
                            <tr>
                                <td>满配重量</td>
                                <td>18.15Kg</td>
                            </tr>
                            
                        </table> 
                    </Modal>
                    <!-- 第三个弹出框 -->
                    <Modal
                        title="产品参数"
                        v-model="modal3"
                        class-name="vertical-center-modal"
                        width="1053"
                        >
                        <table width="963px" border="0" cellpadding="0" cellspacing="0" class="table-modal">
                            <tr>
                                <td width="20%">产品名称</td>
                                <td width="80%">视频实时压缩服务器</td>
                            </tr>
                            <tr>
                               <td>产品型号</td>
                               <td>VDMS-CAS-50/100HB</td>
                            </tr>
                            <tr>
                               <td>外型</td>
                               <td>机架式2U</td>
                            </tr>
                            <tr>
                               <td>处理器</td>
                               <td>E5-2620V4*2</td>
                            </tr>
                            <tr>
                               <td>GPU型号</td>
                               <td>P2000*4</td>
                            </tr>
                            <tr>
                               <td>内存</td>
                               <td>32G</td>
                            </tr>
                            <tr>
                                <td>存储</td>
                                <td>标配1块*3.5英寸1T 7200 rpm SAS硬盘
                                    最大可扩展到8块SAS硬盘，支持2T/4T/6T/8T硬盘</td>
                            </tr>
                            <tr>
                                <td>I/O扩展槽</td>
                                <td>Risers 含最高 3x8 PCIe 插槽 + 1 x16 PCIe 插槽</td>
                            </tr>
                            <tr>
                                <td>集成I/O端口</td>
                                <td>前置：2个USB接口，1个标准VGA接口
                                    后置：1个标准VGA接口，1个千兆管理网口
                                     4个千兆网络接口，2个USB接口</td>
                            </tr>
                            <tr>
                                <td>其他</td>
                                <td>支持DP高清视频接口，配备BMI板卡</td>
                            </tr>
                            <tr>
                                <td>电源</td>
                                <td>额定功率：750W（双电）</td>
                            </tr>
                            <tr>
                                <td>显示控制器</td>
                                <td>主板集成显示控制器+独立显卡控制器</td>
                            </tr>
                            <tr>
                                <td>性能</td>
                                <td>100路（720P）/50路（1080P）视频压缩</td>
                            </tr>
                            <tr>
                                <td>输入视频格式</td>
                                <td>
                                   H.264、H.265、MPEG1/2、MPEG4、RM/RMVB、WMV、DIVX等主流视频格式
                                </td>
                            </tr>
                            <tr>
                                <td>输出视频格式</td>
                                <td>bbw</td>
                            </tr>
                            <tr>
                                <td>传输协议</td>
                                <td>ONVIF、GB/T28181、私有SDK等协议</td>
                            </tr>
                            <tr>
                                <td>工作环境温度</td>                
                                <td>0℃～45℃</td>
                            </tr>
                            <tr>
                                <td>交流输入</td>
                                <td>220V，50Hz</td>
                            </tr>
                            <tr>
                                <td>机箱尺寸</td>
                                <td>87.3mm(高)*444.0mm(宽)*684.0mm(深) </td>
                            </tr>
                            <tr>
                                <td>满配重量</td>
                                <td>18.15Kg</td>
                            </tr>
                            
                        </table> 
                    </Modal>
                    <!-- 第四个弹出框 -->
                    <Modal
                        title="产品参数"
                        v-model="modal4"
                        class-name="vertical-center-modal"
                        width="1053"
                        >
                        <table width="963px" border="0" cellpadding="0" cellspacing="0" class="table-modal">
                            <tr>
                                <td width="20%">产品名称</td>
                                <td width="80%">视频实时压缩服务器</td>
                            </tr>
                            <tr>
                               <td>产品型号</td>
                               <td>VDMS-CAS-75/150HB</td>
                            </tr>
                            <tr>
                               <td>外型</td>
                               <td>机架式2U</td>
                            </tr>
                            <tr>
                               <td>处理器</td>
                               <td>英特尔至强 银牌 4108*2</td>
                            </tr>
                            <tr>
                               <td>GPU型号</td>
                               <td>P2000*6</td>
                            </tr>
                            <tr>
                                <td>存储</td>
                                <td>标配1块*3.5英寸1T 7200 rpm SAS硬盘
                                    最大可扩展到8块SAS硬盘，支持2T/4T/6T/8T硬盘</td>
                            </tr>
                            <tr>
                                <td>I/O扩展槽</td>
                                <td>Risers 含最高 5x8 PCIe 插槽 + 3x16 PCIe 插槽</td>
                            </tr>
                            <tr>
                                <td>集成I/O端口</td>
                                <td>前置：2个USB接口，1个标准VGA接口
                                    后置：1个标准VGA接口，1个千兆管理网口
                                     4个千兆网络接口，2个USB接口</td>
                            </tr>
                            <tr>
                                <td>其他</td>
                                <td>支持DP高清视频接口，配备BMI板卡</td>
                            </tr>
                            <tr>
                                <td>电源</td>
                                <td>额定功率：1100W（双电）</td>
                            </tr>
                            <tr>
                                <td>显示控制器</td>
                                <td>主板集成显示控制器+独立显卡控制器</td>
                            </tr>
                            <tr>
                                <td>性能</td>
                                <td>150路（720P）/75路（1080P）视频压缩</td>
                            </tr>
                            <tr>
                                <td>输入视频格式</td>
                                <td>
                                   H.264、H.265、MPEG1/2、MPEG4、RM/RMVB、WMV、DIVX等主流视频格式
                                </td>
                            </tr>
                            <tr>
                                <td>输出视频格式</td>
                                <td>bbw</td>
                            </tr>
                            <tr>
                                <td>传输协议</td>
                                <td>ONVIF、GB/T28181、私有SDK等协议</td>
                            </tr>
                            <tr>
                                <td>工作环境温度</td>                
                                <td>0℃～45℃</td>
                            </tr>
                            <tr>
                                <td>交流输入</td>
                                <td>220V，50Hz</td>
                            </tr>
                            <tr>
                                <td>机箱尺寸</td>
                                <td>88mm(高)*482mm(宽)*684mm(深)  </td>
                            </tr>
                            <tr>
                                <td>满配重量</td>
                                <td>18.15Kg</td>
                            </tr>
                            
                        </table> 
                    </Modal>

                    <!-- 3.历史视频压缩服务器 -->
                    <div id="right_alllist" class="hide">
                        <div class="product-imges"> 
                            <img src="../../assets/images/108.png" alt=""> 
                            <img src="../../assets/images/81.png" alt="">
                        </div>
                        <div class="lines">历史视频压缩服务器</div>
                        <div class="pro-countent">
                            <div class="product-title">产品简述</div>
                            <p>司马大大以安防为基点，以视频大数据深度应用为目标，融合多种AI算法和十余项创新科技的应用，在编解码过程中，形成独特的编解码方案，在不改变清晰度、不改变帧率、不损失特征点的前提下，实现了高清视频10倍以上的实时无损压缩编解码技术，降低了视频传输和存储的压力，解决了视频结构化存储与有效管理的难题。在此基础上，司马大大还进行了视频智能应用的探索。目前，在行为分析、客流统计、车牌识别、人脸识别、移动目标分析等诸多方面均有实质性突破与项目合作。</p>
                            <p style="margin-bottom: 40px;">公司自主研发的视频压缩服务器，能在保持原有视频清晰度的同时，将原有视频体量压缩1/10-1/30，促使码流增速达90%以上，大幅降低了视频存储的管理成本，提高了数据处理和使用的效率。此项技术可在不改变硬件存储容量的基础上，通过扩容服务器的算法，将原来的高清视频存储量提升十倍以上，填补了视频数据智能化管理产业链的空白。同时，底层自有的编解码技术能够保证信息安全，体现自主可控。</p>
                            <div class="product-title">特点优势</div>
                            <ul>
                                <li><span></span>高效存储：VDMS系统能够在不影响原有视频画质，不改变原有视频帧率、时长的前提下对视频数据进行压缩存储管理，平均可以节省10倍以上的存储空间，大幅降低存储要求和成本</li>
                                <li><span></span>支持多种存储架构：VDMS支持NVR存储、存储服务器存储等分布式存储架构和IP-SAN、FC-SAN等集中存储架构</li>
                                <li><span></span>存储方案灵活：存储方案可采用系统默认分段存储方案，也可根据实际情况对存储效率和存储周期进行调节</li>
                                <li><span></span>视频格式加密：VDMS独特的bbw文件格式，大幅提高数据的安全性和保密性</li>
                                <li><span></span>满足图像客观评价标准：经VDMS处理完后的视频图像峰值信噪比PSNR值不低于32dB，保证视频清晰度</li>
                                <li><span></span>符合安全规范标准：VDMS符合GB/T28181规范等国家标准和行业标准，支持主流的视频和流媒体格式</li>
                            </ul>
                            <div class="product-title" style="margin-top: 60px;">适用场景</div>
                            <p>主要适用于将所有视频数据集中存储到一个或几个数据中心，数据存储量打，存储时间长，前端摄像头多，存储建设成本高等场景。例如：雪亮工程、平安城市等。</p>
                            <p>同时，也适用于上下级录像调取，如市级平台调用县级平台录像卡顿、实时并发路数少等应用场景，VDMS实时视频压缩服务器可以用低码流传输高清视频，增加并发路数。</p>
                            <p style="text-indent: 2em;">例如：雪亮工程、平安城市等。</p>
                            <div class="product-title" style="margin-top: 45px;">产品型号</div>
                            <div>
                                <table width="903px" height="343px" border="0" cellpadding="0" cellspacing="0" class="table-pro">
                                    <tr>
                                        <td width="15%"></td>
                                        <td width="20%" height="60px">产品型号</td>
                                        <td width="50%">性能</td>
                                        <td width="10%">参数</td>
                                    </tr>
                                    <tr>
                                       <td></td>
                                       <td>VDMS-CA-25/50B</td>
                                       <td>塔式，可同时处理25路1080P视频压缩或者50路720P视频压缩（不含存储盘）</td>
                                       <td class="table-joups" @click="modal5 = true">查看</td>
                                       
                                    </tr>
                                    <tr>
                                        <!-- 标题 -->
                                       <td>历史视频压缩服务器</td>
                                       <td>VDMS-CAS-25/50B</td>
                                       <td>机架式，可同时处理25路1080P视频压缩或者50路720P视频压缩（不含存储盘）</td>
                                       <td class="table-joups" @click="modal6 = true">查看</td>
                                    </tr>
                                    
                                    <tr>
                                       <td></td>
                                       <td>VDMS-CAS-50/100B</td>
                                       <td>机架式(双电/2U)，可同时处理50路1080P视频压缩或者100路720P视频压缩（不含存储盘）</td>
                                       <td class="table-joups" @click="modal7 = true">查看</td>
                                    </tr>
                                    <tr>
                                       <td></td>
                                       <td> VDMS-CAS-75/150HB</td>
                                       <td>机架式(双电/2U)，可同时处理75路1080P视频压缩或者150路720P视频压缩（不含存储盘）</td>
                                       <td class="table-joups" @click="modal8 = true">查看</td>
                                    </tr>
                                </table> 
                            </div>
                        </div>
                    </div>
                    <!-- 视频历史压缩服务器  第一个弹出框 -->
                    <Modal
                        title="产品参数"
                        v-model="modal5"
                        class-name="vertical-center-modal"
                        width="1053"
                        >
                        <table width="963px" border="0" cellpadding="0" cellspacing="0" class="table-modal">
                            <tr>
                                <td width="20%">产品名称</td>
                                <td width="80%">视频历史压缩服务器</td>
                            </tr>
                            <tr>
                               <td>产品型号</td>
                               <td>VDMS-CA-25/50B</td>
                            </tr>
                            <tr>
                               <td>外型</td>
                               <td>塔式</td>
                            </tr>
                            <tr>
                               <td>处理器</td>
                               <td>I7 6700K</td>
                            </tr>
                            <tr>
                               <td>GPU型号</td>
                               <td>GTX1070</td>
                            </tr>
                            <tr>
                               <td>内存</td>
                               <td>16GB</td>
                            </tr>
                            <tr>
                                <td>存储</td>
                                <td>标配1块*3.5英寸1T 7200 rpm SATA硬盘最大可扩展到2块SAta硬盘，支持2T/4T/6T/8T硬盘</td>
                            </tr>
                            <tr>
                                <td>集成I/O端口</td>
                                <td>2个千兆网络接口</td>
                            </tr>
                            <tr>
                                <td>其他</td>
                                <td>支持DP高清视频接口，配备BMI板卡</td>
                            </tr>
                            <tr>
                                <td>电源</td>
                                <td>额定功率：550W</td>
                            </tr>
                            <tr>
                                <td>显示控制器</td>
                                <td>主板集成显示控制器+独立显卡控制器</td>
                            </tr>
                            <tr>
                                <td>性能</td>
                                <td>50路（720P）/25路（1080P）视频压缩</td>
                            </tr>
                            <tr>
                                <td>输入视频格式</td>
                                <td>
                                    H.264、H.265、MPEG1/2、MPEG4、RM/RMVB、WMV、DIVX等主流视频格式
                                </td>
                            </tr>
                            <tr>
                                <td>输出视频格式</td>
                                <td>bbw</td>
                            </tr>
                            <tr>
                                <td>传输协议</td>
                                <td>ONVIF、GB/T28181、私有SDK等协议</td>
                            </tr>
                            <tr>
                                <td>工作环境温度</td>                
                                <td>0℃～45℃</td>
                            </tr>
                            <tr>
                                <td>交流输入</td>
                                <td>220V，50Hz</td>
                            </tr>
                            <tr>
                                <td>机箱尺寸</td>
                                <td>475*230*455mm³</td>
                            </tr>
                            <tr>
                                <td>满配重量</td>
                                <td>13.8Kg</td>
                            </tr>
                            
                        </table> 
                    </Modal>
                     <!-- 第二个弹出框 -->
                    <Modal
                        title="产品参数"
                        v-model="modal6"
                        class-name="vertical-center-modal"
                        width="1053"
                        >
                        <table width="963px" border="0" cellpadding="0" cellspacing="0" class="table-modal">
                            <tr>
                                <td width="20%">产品名称</td>
                                <td width="80%">视频历史压缩服务器</td>
                            </tr>
                            <tr>
                               <td>产品型号</td>
                               <td>VDMS-CAS-25/50B</td>
                            </tr>
                            <tr>
                               <td>外型</td>
                               <td>机架式2U</td>
                            </tr>
                            <tr>
                               <td>处理器</td>
                               <td>E5-2620V4</td>
                            </tr>
                            <tr>
                               <td>GPU型号</td>
                               <td>GTX1070</td>
                            </tr>
                            <tr>
                               <td>内存</td>
                               <td>16GB</td>
                            </tr>
                            <tr>
                                <td>RAID</td>
                                <td>支持RAID 0,1,5,10</td>
                            </tr>
                            <tr>
                                <td>存储</td>
                                <td>标配1块*3.5英寸1T 7200 rpm SAS硬盘
                                    最大可扩展到8块SAS硬盘，支持2T/4T/6T/8T硬盘</td>
                            </tr>
                            <tr>
                                <td>I/O扩展槽</td>
                                <td>Risers 含最高 3x8 PCIe 插槽 + 1x16 PCIe 插槽</td>
                            </tr>
                            <tr>
                                <td>集成I/O端口</td>
                                <td>前置：2个USB接口，1个标准VGA接口
                                    后置：1个标准VGA接口，1个千兆管理网口
                                     4个千兆网络接口，2个USB接口</td>
                            </tr>
                            <tr>
                                <td>其他</td>
                                <td>支持DP高清视频接口，配备BMI板卡</td>
                            </tr>
                            <tr>
                                <td>电源</td>
                                <td>额定功率：750W（双电）</td>
                            </tr>
                            <tr>
                                <td>显示控制器</td>
                                <td>主板集成显示控制器+独立显卡控制器</td>
                            </tr>
                            <tr>
                                <td>性能</td>
                                <td>50路（720P）/25路（1080P）视频压缩</td>
                            </tr>
                            <tr>
                                <td>输入视频格式</td>
                                <td>
                                   H.264、H.265、MPEG1/2、MPEG4、RM/RMVB、WMV、DIVX等主流视频格式
                                </td>
                            </tr>
                            <tr>
                                <td>输出视频格式</td>
                                <td>bbw</td>
                            </tr>
                            <tr>
                                <td>传输协议</td>
                                <td>ONVIF、GB/T28181、私有SDK等协议</td>
                            </tr>
                            <tr>
                                <td>工作环境温度</td>                
                                <td>0℃～45℃</td>
                            </tr>
                            <tr>
                                <td>交流输入</td>
                                <td>220V，50Hz</td>
                            </tr>
                            <tr>
                                <td>机箱尺寸</td>
                                <td>87.3mm(高)*444.0mm(宽)*684.0mm(深)</td>
                            </tr>
                            <tr>
                                <td>满配重量</td>
                                <td>18.15Kg</td>
                            </tr>
                            
                        </table> 
                    </Modal>
                    <!-- 第三个弹出框 -->
                    <Modal
                        title="产品参数"
                        v-model="modal7"
                        class-name="vertical-center-modal"
                        width="1053"
                        >
                        <table width="963px" border="0" cellpadding="0" cellspacing="0" class="table-modal">
                            <tr>
                                <td width="20%">产品名称</td>
                                <td width="80%">视频历史压缩服务器</td>
                            </tr>
                            <tr>
                               <td>产品型号</td>
                               <td>VDMS-CAS-50/100B</td>
                            </tr>
                            <tr>
                               <td>外型</td>
                               <td>机架式2U</td>
                            </tr>
                            <tr>
                               <td>处理器</td>
                               <td>E5-2620V4*2</td>
                            </tr>
                            <tr>
                               <td>GPU型号</td>
                               <td>GTX1070+P2000*2</td>
                            </tr>
                            <tr>
                                <td>存储</td>
                                <td>标配1块*3.5英寸1T 7200 rpm SAS硬盘
                                    最大可扩展到8块SAS硬盘，支持2T/4T/6T/8T硬盘</td>
                            </tr>
                            <tr>
                                <td>I/O扩展槽</td>
                                <td>Risers 含最高 3x8 PCIe 插槽 + 1 x16 PCIe 插槽</td>
                            </tr>
                            <tr>
                                <td>集成I/O端口</td>
                                <td>前置：2个USB接口，1个标准VGA接口
                                    后置：1个标准VGA接口，1个千兆管理网口
                                     4个千兆网络接口，2个USB接口</td>
                            </tr>
                            <tr>
                                <td>其他</td>
                                <td>支持DP高清视频接口，配备BMI板卡</td>
                            </tr>
                            <tr>
                                <td>电源</td>
                                <td>额定功率：750W（双电）</td>
                            </tr>
                            <tr>
                                <td>显示控制器</td>
                                <td>主板集成显示控制器+独立显卡控制器</td>
                            </tr>
                            <tr>
                                <td>性能</td>
                                <td>100路（720P）/50路（1080P）视频压缩</td>
                            </tr>
                            <tr>
                                <td>输入视频格式</td>
                                <td>
                                   H.264、H.265、MPEG1/2、MPEG4、RM/RMVB、WMV、DIVX等主流视频格式
                                </td>
                            </tr>
                            <tr>
                                <td>输出视频格式</td>
                                <td>bbw</td>
                            </tr>
                            <tr>
                                <td>传输协议</td>
                                <td>ONVIF、GB/T28181、私有SDK等协议</td>
                            </tr>
                            <tr>
                                <td>工作环境温度</td>                
                                <td>0℃～45℃</td>
                            </tr>
                            <tr>
                                <td>交流输入</td>
                                <td>220V，50Hz</td>
                            </tr>
                            <tr>
                                <td>机箱尺寸</td>
                                <td>87.3mm(高)*444.0mm(宽)*684.0mm(深)</td>
                            </tr>
                            <tr>
                                <td>满配重量</td>
                                <td>18.15Kg</td>
                            </tr>
                            
                        </table> 
                    </Modal>
                    <!-- 第四个弹出框 -->
                    <Modal
                        title="产品参数"
                        v-model="modal8"
                        class-name="vertical-center-modal"
                        width="1053"
                        >
                        <table width="963px" border="0" cellpadding="0" cellspacing="0" class="table-modal">
                            <tr>
                                <td width="20%">产品名称</td>
                                <td width="80%">视频历史压缩服务器</td>
                            </tr>
                            <tr>
                               <td>产品型号</td>
                               <td>VDMS-CAS-75/150HB</td>
                            </tr>
                            <tr>
                               <td>外型</td>
                               <td>机架式2U</td>
                            </tr>
                            <tr>
                               <td>处理器</td>
                               <td>英特尔至强 银牌 4108*2</td>
                            </tr>
                            <tr>
                               <td>GPU型号</td>
                               <td>P2000*6</td>
                            </tr>
                            <tr>
                                <td>存储</td>
                                <td>标配2块*3.5英寸1T 7200 rpm SAS硬盘
                                    最大可扩展到8块SAS硬盘，支持2T/4T/6T/8T硬盘</td>
                            </tr>
                            <tr>
                                <td>I/O扩展槽</td>
                                <td>Risers 含最高 5x8 PCIe 插槽 + 3x16 PCIe 插槽</td>
                            </tr>
                            <tr>
                                <td>集成I/O端口</td>
                                <td>前置：2个USB接口，1个标准VGA接口
                                    后置：1个标准VGA接口，1个千兆管理网口
                                     4个千兆网络接口，2个USB接口</td>
                            </tr>
                            <tr>
                                <td>其他</td>
                                <td>支持DP高清视频接口，配备BMI板卡</td>
                            </tr>
                            <tr>
                                <td>电源</td>
                                <td>额定功率：1100W（双电）</td>
                            </tr>
                            <tr>
                                <td>显示控制器</td>
                                <td>主板集成显示控制器+独立显卡控制器</td>
                            </tr>
                            <tr>
                                <td>性能</td>
                                <td>150路（720P）/75路（1080P）视频压缩</td>
                            </tr>
                            <tr>
                                <td>输入视频格式</td>
                                <td>
                                   H.264、H.265、MPEG1/2、MPEG4、RM/RMVB、WMV、DIVX等主流视频格式
                                </td>
                            </tr>
                            <tr>
                                <td>输出视频格式</td>
                                <td>bbw</td>
                            </tr>
                            <tr>
                                <td>传输协议</td>
                                <td>ONVIF、GB/T28181、私有SDK等协议</td>
                            </tr>
                            <tr>
                                <td>工作环境温度</td>                
                                <td>0℃～45℃</td>
                            </tr>
                            <tr>
                                <td>交流输入</td>
                                <td>220V，50Hz</td>
                            </tr>
                            <tr>
                                <td>机箱尺寸</td>
                                <td>88mm(高)*482mm(宽)*684mm(深) </td>
                            </tr>
                            <tr>
                                <td>满配重量</td>
                                <td>18.15Kg</td>
                            </tr>
                            
                        </table> 
                    </Modal>

                    <!-- 4.视频转码服务器 -->
                    <div id="right_alllist" class="hide">
                        <div class="product-imgess" >  
                            <img src="../../assets/images/81.png" alt="">
                        </div>
                        <div class="lines">视频转码服务器</div>
                        <div class="pro-countent">
                            <div class="product-title">产品简述</div>
                            <p style="margin-bottom: 40px;">本产品用于对接第三方应用平台，将视频压缩服务器压缩后的bbw码流转换成标准H.264或国标流。</p>
                            <div class="product-title">特点优势</div>
                            <ul>
                                <li><span></span>支持多种平台架构：VDMS转码服务器支持与其他平台通过国标GB/T28181、ONVIF、私有SDK对接。</li>
                                <li><span></span>满足图像客观评价标准：经转码服务器转换成标准流的视频图像峰值信噪比PSNR值不低于32dB，保证视频清晰度</li>
                                <li><span></span>符合安全规范标准：VDMS符合GB/T28181规范等国家标准和行业标准</li>
                            </ul>
                            <div class="product-title" style="margin-top: 60px;">适用场景</div>
                            <p>主要适用于VDMS实时压缩或历史压缩系统下bbw转码标准格式。</p>
                            <div class="product-title" style="margin-top: 45px;">产品型号</div>
                            <div>
                                <table width="903px" height="343px" border="0" cellpadding="0" cellspacing="0" class="table-pro">
                                    <tr>
                                        <td width="15%"></td>
                                        <td width="20%" height="60px">产品型号</td>
                                        <td width="50%">性能</td>
                                        <td width="10%">参数</td>
                                    </tr>
                                    <tr>
                                       <td></td>
                                       <td>VDMS-FS-25/50B</td>
                                       <td>机架式，可同时处理25路1080p或者50路720p实时转码（*bbw转通用格式）（不含存储盘）</td>
                                       <td class="table-joups" @click="modal9 = true">查看</td>
                                       
                                    </tr>
                                    <tr>
                                        <!-- 标题 -->
                                       <td>视频转码服务器</td>
                                       <td>VDMS-FS-50/100B</td>
                                       <td>机架式，可同时处理50路1080p或者100路720p实时转码（*bbw转通用格式）（不含存储盘）</td>
                                       <td class="table-joups" @click="modal11 = true">查看</td>
                                    </tr>
                                    
                                    <tr>
                                       <td></td>
                                       <td>VDMS-FS-75/150B</td>
                                       <td>机架式，可同时处理75路1080p或者150路720p实时转码（*bbw转通用格式）（不含存储盘）</td>
                                       <td class="table-joups" @click="modal12 = true">查看</td>
                                    </tr>
                                </table> 
                            </div>
                        </div>
                    </div>
                    <!-- 视频转码服务器  第一个弹出框 -->
                    <Modal
                        title="产品参数"
                        v-model="modal9"
                        class-name="vertical-center-modal"
                        width="1053"
                        >
                        <table width="963px" border="0" cellpadding="0" cellspacing="0" class="table-modal">
                            <tr>
                                <td width="20%">产品名称</td>
                                <td width="80%">视频转码服务器</td>
                            </tr>
                            <tr>
                               <td>产品型号</td>
                               <td>VDMS-FS-25/50B</td>
                            </tr>
                            <tr>
                               <td>外型</td>
                               <td>机架式2U</td>
                            </tr>
                            <tr>
                               <td>处理器</td>
                               <td>E5-2620V4</td>
                            </tr>
                            <tr>
                               <td>GPU型号</td>
                               <td>P2000*2</td>
                            </tr>
                            <tr>
                               <td>内存</td>
                               <td>16GB</td>
                            </tr>
                            <tr>
                                <td>RAID</td>
                                <td>支持RAID 0,1,5,10</td>
                            </tr>
                            <tr>
                                <td>存储</td>
                                <td>标配1块*3.5英寸1T 7200 rpm SAS硬盘最大可扩展到8块SAS硬盘，支持2T/4T/6T/8T硬盘</td>
                            </tr>
                            <tr>
                                <td>I/O扩展槽</td>
                                <td>Risers 含最高 3x8 PCIe 插槽 + 1x16 PCIe 插槽</td>
                            </tr>
                            <tr>
                                <td>集成I/O端口</td>
                                <td>前置：2个USB接口，1个标准VGA接口
                                    后置：1个标准VGA接口，1个千兆管理网口
                                     4个千兆网络接口，2个USB接口</td>
                            </tr>
                            <tr>
                                <td>其他</td>
                                <td>支持DP高清视频接口，配备BMI板卡</td>
                            </tr>
                            <tr>
                                <td>电源</td>
                                <td>额定功率：750W（双电）</td>
                            </tr>
                            <tr>
                                <td>显示控制器</td>
                                <td>主板集成显示控制器+独立显卡控制器</td>
                            </tr>
                            <tr>
                                <td>性能</td>
                                <td>支持50路（720P）/25路（1080P）实时转码（*bbw转通用格式）</td>
                            </tr>
                            <tr>
                                <td>输入视频格式</td>
                                <td>
                                    H.264、H.265、MPEG1/2、MPEG4等主流视频格式
                                </td>
                            </tr>
                            <tr>
                                <td>输出视频格式</td>
                                <td>bbw</td>
                            </tr>
                            <tr>
                                <td>传输协议</td>
                                <td>ONVIF、GB/T28181、私有SDK等协议</td>
                            </tr>
                            <tr>
                                <td>工作环境温度</td>                
                                <td>0℃～45℃</td>
                            </tr>
                            <tr>
                                <td>交流输入</td>
                                <td>220V，50Hz</td>
                            </tr>
                            <tr>
                                <td>机箱尺寸</td>
                                <td>87.3mm(高)*444.0mm(宽)*684.0mm(深)</td>
                            </tr>
                            <tr>
                                <td>满配重量</td>
                                <td>18.15Kg</td>
                            </tr>
                            
                        </table> 
                    </Modal>
                    <!-- 第二个弹出框 -->
                    <Modal
                        title="产品参数"
                        v-model="modal11"
                        class-name="vertical-center-modal"
                        width="1053"
                        >
                        <table width="963px" border="0" cellpadding="0" cellspacing="0" class="table-modal">
                            <tr>
                                <td width="20%">产品名称</td>
                                <td width="80%">视频转码服务器</td>
                            </tr>
                            <tr>
                               <td>产品型号</td>
                               <td>VDMS-FS-50/100B</td>
                            </tr>
                            <tr>
                               <td>外型</td>
                               <td>机架式2U</td>
                            </tr>
                            <tr>
                               <td>处理器</td>
                               <td>E5-2620V4*2</td>
                            </tr>
                            <tr>
                               <td>GPU型号</td>
                               <td>P2000*4</td>
                            </tr>
                            <tr>
                               <td>内存</td>
                               <td>32GB</td>
                            </tr>
                            <tr>
                                <td>RAID</td>
                                <td>支持RAID 0,1,5,10</td>
                            </tr>
                            <tr>
                                <td>存储</td>
                                <td>标配1块*3.5英寸1T 7200 rpm SAS硬盘最大可扩展到8块SAS硬盘，支持2T/4T/6T/8T硬盘</td>
                            </tr>
                            <tr>
                                <td>I/O扩展槽</td>
                                <td>Risers 含最高 3x8 PCIe 插槽 + 1x16 PCIe 插槽</td>
                            </tr>
                            <tr>
                                <td>集成I/O端口</td>
                                <td>前置：2个USB接口，1个标准VGA接口
                                    后置：1个标准VGA接口，1个千兆管理网口
                                     4个千兆网络接口，2个USB接口</td>
                            </tr>
                            <tr>
                                <td>其他</td>
                                <td>支持DP高清视频接口，配备BMI板卡</td>
                            </tr>
                            <tr>
                                <td>电源</td>
                                <td>额定功率：750W（双电）</td>
                            </tr>
                            <tr>
                                <td>显示控制器</td>
                                <td>主板集成显示控制器+独立显卡控制器</td>
                            </tr>
                            <tr>
                                <td>性能</td>
                                <td>支持50路（720P）/25路（1080P）视频转码</td>
                            </tr>
                            <tr>
                                <td>输入视频格式</td>
                                <td>
                                    H.264、H.265、MPEG1/2、MPEG4、RM/RMVB、WMV、DIVX等主流视频格式
                                </td>
                            </tr>
                            <tr>
                                <td>输出视频格式</td>
                                <td>bbw</td>
                            </tr>
                            <tr>
                                <td>传输协议</td>
                                <td>ONVIF、GB/T28181、私有SDK等协议</td>
                            </tr>
                            <tr>
                                <td>工作环境温度</td>                
                                <td>0℃～45℃</td>
                            </tr>
                            <tr>
                                <td>交流输入</td>
                                <td>220V，50Hz</td>
                            </tr>
                            <tr>
                                <td>机箱尺寸</td>
                                <td>87.3mm(高)*444.0mm(宽)*684.0mm(深)</td>
                            </tr>
                            <tr>
                                <td>满配重量</td>
                                <td>18.15Kg</td>
                            </tr>
                            
                        </table> 
                    </Modal>
                    <!-- 第三个弹出框 -->
                    <Modal
                        title="产品参数"
                        v-model="modal12"
                        class-name="vertical-center-modal"
                        width="1053"
                        >
                        <table width="963px" border="0" cellpadding="0" cellspacing="0" class="table-modal">
                            <tr>
                                <td width="20%">产品名称</td>
                                <td width="80%">视频转码服务器</td>
                            </tr>
                            <tr>
                               <td>产品型号</td>
                               <td>VDMS-FS-75/150B</td>
                            </tr>
                            <tr>
                               <td>外型</td>
                               <td>机架式2U</td>
                            </tr>
                            <tr>
                               <td>处理器</td>
                               <td>英特尔至强 银牌 4108*2</td>
                            </tr>
                            <tr>
                               <td>GPU型号</td>
                               <td>P2000*6</td>
                            </tr>
                            <tr>
                               <td>内存</td>
                               <td>32GB</td>
                            </tr>
                            <tr>
                                <td>RAID</td>
                                <td>支持RAID 0,1,5,10</td>
                            </tr>
                            <tr>
                                <td>存储</td>
                                <td>标配1块*3.5英寸1T 7200 rpm SAS硬盘最大可扩展到8块SAS硬盘，支持2T/4T/6T/8T硬盘</td>
                            </tr>
                            <tr>
                                <td>I/O扩展槽</td>
                                <td>Risers 含最高 5x8 PCIe 插槽 + 3x16 PCIe 插槽</td>
                            </tr>
                            <tr>
                                <td>集成I/O端口</td>
                                <td>前置：2个USB接口，1个标准VGA接口
                                    后置：1个标准VGA接口，1个千兆管理网口
                                     4个千兆网络接口，2个USB接口</td>
                            </tr>
                            <tr>
                                <td>其他</td>
                                <td>支持DP高清视频接口，配备BMI板卡</td>
                            </tr>
                            <tr>
                                <td>电源</td>
                                <td>额定功率：1100W（双电）</td>
                            </tr>
                            <tr>
                                <td>显示控制器</td>
                                <td>主板集成显示控制器+独立显卡控制器</td>
                            </tr>
                            <tr>
                                <td>性能</td>
                                <td>支持150路（720P）/75路（1080P）视频转码</td>
                            </tr>
                            <tr>
                                <td>输入视频格式</td>
                                <td>
                                    H.264、H.265、MPEG1/2、MPEG4、RM/RMVB、WMV、DIVX等主流视频格式
                                </td>
                            </tr>
                            <tr>
                                <td>输出视频格式</td>
                                <td>bbw</td>
                            </tr>
                            <tr>
                                <td>传输协议</td>
                                <td>ONVIF、GB/T28181、私有SDK等协议</td>
                            </tr>
                            <tr>
                                <td>工作环境温度</td>                
                                <td>0℃～45℃</td>
                            </tr>
                            <tr>
                                <td>交流输入</td>
                                <td>220V，50Hz</td>
                            </tr>
                            <tr>
                                <td>机箱尺寸</td>
                                <td>86.8mm(高)*482.0mm(宽)*715.5mm(深)</td>
                            </tr>
                            <tr>
                                <td>满配重量</td>
                                <td>18.15Kg</td>
                            </tr>
                            
                        </table> 
                    </Modal>

                    <!-- 5.VDMS系统管理服务器 -->
                    <div id="right_alllist" class="hide">
                        <div class="product-imgess" >  
                            <img src="../../assets/images/81.png" alt="">
                        </div>
                        <div class="lines">VDMS系统管理服务器</div>
                        <div class="pro-countent">
                            <div class="product-title">产品简述</div>
                            <p style="margin-bottom: 40px;">本产品支持分布式架构，用于管理VDMS系统下的实时压缩服务器、视频历史压缩服务器、视频转码服务器。</p>
                            <div class="product-title">特点优势</div>
                            <ul>
                                <li><span></span>负载均衡：VDMS管理服务器可以调整VDMS系统下的实时压缩服务器、视频历史压缩服务器、视频转码服务器资源利用，保证每台设备的资源高效、充分的利用</li>
                                <li><span></span>故障迁移：当VDMS系统下的单台或多台设备出现故障或宕机时，VDMS管理服务器可以将发生故障服务器的工作分配给其他有空余资源的服务器或热备服务器，保证设备的稳定运行。</li>
                                <li><span></span>信令接入：为整个VDMS系统提供信令接入和管理，如国标对接、存储对接、媒体转发等信令的发送、接收和处理。</li>
                                <li><span></span>符合安全规范标准：VDMS符合GB/T28181规范等国家标准和行业标准</li>
                            </ul>
                            <div class="product-title" style="margin-top: 60px;">适用场景</div>
                            <p>主要适用于管理多台VDMS实时压缩或历史压缩、转码服务器集群使用的环境。</p>
                            <div class="product-title" style="margin-top: 45px;">产品型号</div>
                            <div>
                                <table width="903px" height="343px" border="0" cellpadding="0" cellspacing="0" class="table-pro">
                                    <tr>
                                        <td width="15%"></td>
                                        <td width="20%" height="60px">产品型号</td>
                                        <td width="50%">性能</td>
                                        <td width="10%">参数</td>
                                    </tr>
                                    <tr>
                                        <!-- 标题 -->
                                       <td>VDMS系统管理服务器</td>
                                       <td>VDMS-CAMS-12/25B</td>
                                       <td>机架式(双电/2U)，可同时管理40台以下VDMS-CAS-50/100B或者80台以下VDMS-CAS-25/50B（不含存储盘）</td>
                                       <td class="table-joups" @click="modal13 = true">查看</td>
                                    </tr>
                                    
                                </table> 
                            </div>
                        </div>
                    </div>
                    <!-- 第三个弹出框 -->
                    <Modal
                        title="产品参数"
                        v-model="modal13"
                        class-name="vertical-center-modal"
                        width="1053"
                        >
                        <table width="963px" border="0" cellpadding="0" cellspacing="0" class="table-modal">
                            <tr>
                                <td width="20%">产品名称</td>
                                <td width="80%">视频数据管理服务器</td>
                            </tr>
                            <tr>
                               <td>产品型号</td>
                               <td>VDMS-CAMS-12/25B</td>
                            </tr>
                            <tr>
                               <td>外型</td>
                               <td>机架式2U</td>
                            </tr>
                            <tr>
                               <td>处理器</td>
                               <td>E5-2620V4</td>
                            </tr>
                            <tr>
                               <td>内存</td>
                               <td>32GB</td>
                            </tr>
                            <tr>
                                <td>RAID</td>
                                <td>支持RAID 0,1,5,10</td>
                            </tr>
                            <tr>
                                <td>存储</td>
                                <td>标配1块*3.5英寸1T 7200 rpm SAS硬盘最大可扩展到8块SAS硬盘，支持2T/4T/6T/8T硬盘</td>
                            </tr>
                            <tr>
                                <td>I/O扩展槽</td>
                                <td>Risers 含最高 3x8 PCIe 插槽 + 1x16 PCIe 插槽</td>
                            </tr>
                            <tr>
                                <td>集成I/O端口</td>
                                <td>前置：2个USB接口，1个标准VGA接口
                                    后置：1个标准VGA接口，1个千兆管理网口
                                     4个千兆网络接口，2个USB接口</td>
                            </tr>
                            <tr>
                                <td>其他</td>
                                <td>支持DP高清视频接口，配备BMI板卡</td>
                            </tr>
                            <tr>
                                <td>电源</td>
                                <td>额定功率：750W（双电）</td>
                            </tr>
                            <tr>
                                <td>显示控制器</td>
                                <td>主板集成显示控制器+独立显卡控制器</td>
                            </tr>
                            <tr>
                                <td>性能</td>
                                <td>机架式(双电/2U)，可同时管理40台以下VDMS-CAS-50/100B或者80台以下VDMS-CAS-25/50B（不含存储盘）</td>
                            </tr>
                            <tr>
                                <td>输入视频格式</td>
                                <td>
                                    H.264、H.265、MPEG1/2、MPEG4、RM/RMVB、WMV、DIVX等主流视频格式
                                </td>
                            </tr>
                            <tr>
                                <td>输出视频格式</td>
                                <td>bbw</td>
                            </tr>
                            <tr>
                                <td>传输协议</td>
                                <td>ONVIF、GB/T28181、私有SDK等协议</td>
                            </tr>
                            <tr>
                                <td>工作环境温度</td>                
                                <td>0℃～45℃</td>
                            </tr>
                            <tr>
                                <td>交流输入</td>
                                <td>220V，50Hz</td>
                            </tr>
                            <tr>
                                <td>机箱尺寸</td>
                                <td>87.3mm(高)*444.0mm(宽)*684.0mm(深)</td>
                            </tr>
                            <tr>
                                <td>满配重量</td>
                                <td>18.15Kg</td>
                            </tr>
                            
                        </table> 
                    </Modal>

                    <!-- 6.MT视频压缩处理器-184 -->
                    <div id="right_alllist" class="hide">
                        <div class="product-imgesss" >  
                            <img src="../../assets/images/159.png" alt="">
                        </div>
                        <div class="lines">VDMS-MT-184</div>
                        <div class="pro-countent">
                            <div class="product-title">产品简述</div>
                            <p style="text-indent: 2em;">MT系列视频压缩处理器是司马大大自主研发的基于机器视觉和人工智能检索技术于一体的智能型实时压缩产品，该产品主要为用户解决海量高清视频存储问题及因带宽不足导致调用高清视频路数受限等情况。</p>
                            <p style="text-indent: 2em;">MT系列视频压缩处理器视频输入输出均支持国标协议，压缩后的视频可与现有存储设备做块存储、对象存储、文件存储等多种存储协议的无缝对接，真正做到不破坏现有存储架构的同时做完美融合。</p>
                            <p style="text-indent: 2em;">MT系列视频压缩处理器通过自主研发的核心技术可在不改变帧率、不改变视频分辨率、不改变时长、不损失特征点、不影响后续AI智能分析等条件下实现高清视频平均10倍以上无损压缩，压缩后视频文件大小平均为原文件大小的1/10，针对动态场景较少的环境，例如IDC机房，视频平均可压缩20倍以上。</p>
                            <p style="margin-bottom: 40px;"></p>
                            <div class="product-title">特点优势</div>
                            <ul>
                                <li><span></span>高效存储：经MT系列视频压缩处理器压缩后的视频能够在不改变视频帧率、分辨率、不损失特征点的前提下平均压缩至原视频的1/10,较常规存储平均节省10倍以上的空间，减少了存储容量和存储设备，可将机房的建设成本降低10%-20%。</li>
                                <li><span></span>低码流传输：经MT系列视频压缩处理器压缩后的视频，码流将压缩至原视频的1/10,较常规存储平均节省9/10的传输带宽，大幅降低带宽负荷，解决低带宽传输高清视频受限的问题。</li>
                                <li><span></span>便于维护：压缩设备采用SOC架构，板卡式压缩，板卡支持热插拔。</li>
                                <li><span></span>支持与第三方平台的多协议对接：支持与现有视频监控平台进行无缝对接（支持ONVIF、GB/T28181、GB/T35114等协议）</li>
                                <li><span></span>支持各大品牌摄像机的接入：支持通过ONVIF、GB28181、私有SDK等多种协议与现有各大厂商的监控设备做接入</li>
                                <li><span></span>支持多类存储对接：系统支持与阵列式存储、IPSAN、蓝光存储、存储服务器、云存储等多种存储设备进行块存储、文件存储、对象存储等存储协议的无缝对接，适用于现有系统改造、老存储利旧、新建数据中心存储等多种项目模式。</li>
                                <li><span></span>支持标准编码格式：MT系列产品支持标准H.264或H.265等主流流媒体编码格式输入，支持BBW视频编码格式输出（平台调用时支持转换为国标编码格式输出）。</li>
                                <li><span></span>节省机柜 减少空间占用：VDMS系统硬件采用的都是标准2U刀片式服务器，减少存储占用机房空间的同时进一步提升空间利用率，有效节省机柜数量。</li>
                                <li><span></span>减少硬盘损耗 节约维护成本：在实际项目应用中，硬盘每年都有一定的损坏率，最高甚至达到10%以上，这会增加后期的运维成本。通过VDMS 系统与存储配合应用，在保证所有视频画质清晰的同时大量减少硬盘数量，大幅降低每年硬盘更换数量，节约维护成本。</li>
                                <li><span></span>节能省电 绿色环保：设备满载情况下，功耗仅为150W，相当的节能省电。</li>
                                <li><span></span>灵活性高：MT系列产品最高支持接入24块嵌入式视频压缩板卡，每张板卡支持8路1080P视频处理，可根据项目实际需求灵活配置板卡数量，闲置卡槽支持后续扩容。</li>
                                <li><span></span>系统支持分布式管理，提供负载均衡及故障迁移功能</li>
                                <li><span></span>双电源机制：MT视频压缩处理器采用双路电源输入设计，避免单路供电线路故障，导致重要监控数据丢失，该设计为系统持续稳定的运行起到至关重要的作用。</li>
                            </ul>
                            <div class="product-title" style="margin-top: 60px;">适用场景</div>
                            <p>主要适用于将所有视频数据集中存储到一个或几个数据中心，数据存储量打，存储时间长，前端摄像头多，存储建设成本高等场景。</p>
                             <p style="text-indent: 2em;">例如：雪亮工程、平安城市等。</p>
                        </div>
                    </div>

                    <!-- 7.MT视频压缩处理器-512 -->
                    <div id="right_alllist" class="hide">
                        <div class="product-imgesss" >  
                            <img src="../../assets/images/160.png" alt="">
                        </div>
                        <div class="lines">VDMS-MT-512</div>
                        <div class="pro-countent">
                            <div class="product-title">产品简述</div>
                            <p style="text-indent: 2em;">MT系列视频压缩处理器是司马大大自主研发的基于机器视觉和人工智能检索技术于一体的智能型实时压缩产品，该产品主要为用户解决海量高清视频存储问题及因带宽不足导致调用高清视频路数受限等情况。</p>
                            <p style="text-indent: 2em;">MT系列视频压缩处理器视频输入输出均支持国标协议，压缩后的视频可与现有存储设备做块存储、对象存储、文件存储等多种存储协议的无缝对接，真正做到不破坏现有存储架构的同时做完美融合。</p>
                            <p style="text-indent: 2em;">MT系列视频压缩处理器通过自主研发的核心技术可在不改变帧率、不改变视频分辨率、不改变时长、不损失特征点、不影响后续AI智能分析等条件下实现高清视频平均10倍以上无损压缩，压缩后视频文件大小平均为原文件大小的1/10，针对动态场景较少的环境，例如IDC机房，视频平均可压缩20倍以上。</p>
                            <p style="margin-bottom: 40px;"></p>
                            <div class="product-title">特点优势</div>
                            <ul>
                                <li><span></span>高效存储：经MT系列视频压缩处理器压缩后的视频能够在不改变视频帧率、分辨率、不损失特征点的前提下平均压缩至原视频的1/10,较常规存储平均节省10倍以上的空间，减少了存储容量和存储设备，可将机房的建设成本降低10%-20%。</li>
                                <li><span></span>低码流传输：经MT系列视频压缩处理器压缩后的视频，码流将压缩至原视频的1/10,较常规存储平均节省9/10的传输带宽，大幅降低带宽负荷，解决低带宽传输高清视频受限的问题。</li>
                                <li><span></span>便于维护：压缩设备采用SOC架构，板卡式压缩，板卡支持热插拔。</li>
                                <li><span></span>支持与第三方平台的多协议对接：支持与现有视频监控平台进行无缝对接（支持ONVIF、GB/T28181、GB/T35114等协议）</li>
                                <li><span></span>支持各大品牌摄像机的接入：支持通过ONVIF、GB28181、私有SDK等多种协议与现有各大厂商的监控设备做接入</li>
                                <li><span></span>支持多类存储对接：系统支持与阵列式存储、IPSAN、蓝光存储、存储服务器、云存储等多种存储设备进行块存储、文件存储、对象存储等存储协议的无缝对接，适用于现有系统改造、老存储利旧、新建数据中心存储等多种项目模式。</li>
                                <li><span></span>支持标准编码格式：MT系列产品支持标准H.264或H.265等主流流媒体编码格式输入，支持BBW视频编码格式输出（平台调用时支持转换为国标编码格式输出）。</li>
                                <li><span></span>节省机柜 减少空间占用：VDMS系统硬件采用的都是标准4U刀片式服务器，减少存储占用机房空间的同时进一步提升空间利用率，有效节省机柜数量。</li>
                                <li><span></span>减少硬盘损耗 节约维护成本：在实际项目应用中，硬盘每年都有一定的损坏率，最高甚至达到10%以上，这会增加后期的运维成本。通过VDMS 系统与存储配合应用，在保证所有视频画质清晰的同时大量减少硬盘数量，大幅降低每年硬盘更换数量，节约维护成本。</li>
                                <li><span></span>节能省电 绿色环保：设备满载情况下，功耗仅为330W，相当的节能省电。</li>
                                <li><span></span>灵活性高：MT系列产品最高支持接入72块嵌入式视频压缩板卡，每张板卡支持8路1080P视频处理，可根据项目实际需求灵活配置板卡数量，闲置卡槽支持后续扩容。</li>
                                <li><span></span>系统支持分布式管理，提供负载均衡及故障迁移功能</li>
                                <li><span></span>双电源机制：MT视频压缩处理器采用双路电源输入设计，避免单路供电线路故障，导致重要监控数据丢失，该设计为系统持续稳定的运行起到至关重要的作用。</li>
                            </ul>
                            <div class="product-title" style="margin-top: 60px;">适用场景</div>
                            <p>主要适用于将所有视频数据集中存储到一个或几个数据中心，数据存储量打，存储时间长，前端摄像头多，存储建设成本高等场景。</p>
                             <p style="text-indent: 2em;">例如：雪亮工程、平安城市等。</p>
                        </div>
                    </div>


                </div>
            </div>

        </div>

    </div>
</template>

<script>
import $ from "../../../node_modules/jquery/dist/jquery.js";
import header from "../cuscom/header";
export default {
    data() {
        return {
            modal10: false,
            modal1: false,
            modal2: false,
            modal3: false,
            modal4: false,
            modal5: false,
            modal6: false,
            modal7: false,
            modal8: false,
            modal9: false,
            modal11: false,
            modal12: false,
            modal13: false,
        }
    },

    mounted:function(){
        $(".prc_updown #tab-list").click(function () {
                $(".prc_cards #right_alllist").eq($(this).index()).removeClass("hide").siblings().addClass("hide");
                $('.prc_updown #tab-list:nth-child(1)').removeClass("active-list");
                $(".prc_updown #tab-list").eq($(this).index()).addClass("active-list").siblings().removeClass("active-list");
            });

        
    },
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },

}
</script>

<style>
 .product-warp {
     background: #f0fcfd;
     color: #333333;
 }
 .product-banner {
     width: 100%;
     /* height: 562px; */
 }
 .product-banner img {
     width: 100%;
     /* height: 100%; */
 }


 /* 核心产品内容 */
 .product-main {
     width: 1200px;
     margin: 0 auto;
     overflow: hidden;
     /* margin-bottom: 65px;  */
 }

 .prc-content {
     margin-top: 104px;
     margin-bottom: 100px;
 }


/* 左侧 */
.prc_updown {
    width: 220px;
    float: left;
}

.prc_updown li {
    list-style: none;
    font-size: 18px;
    color: #333333;
    height: 50px;
    border-bottom: solid #dddddd 1px;
    line-height: 50px;
    padding-left: 23px;
    cursor: pointer;
    margin-top: 0px;
}
.prc_updown li:nth-child(1) {
   border-top: 1px solid #dddddd;
}
.prc_updown .title_li {
    font-size: 24px;
    padding: 0;
    margin-bottom: 10px;
}


.prc_updown .active-list {
    color: #29b3de;
}


/* 右侧 */
.prc_cards {
    width: 955px;
    background:  #fbfbfb;
    word-break: break-all;
    padding-bottom:2000px;
    margin-bottom:-1950px;
    float: right;
}

/* 视频智能处理器 */
.product-img {
    width: 393px;
    height: 281px;
    padding-top: 42px;
    margin: 0 auto;
    margin-bottom: 70px;
}
.product-img img {
    width: 100%;
    height: 100%;
}
/* 分割线 */
.liness {
  font-size: 24px;
  text-align: center;
  width: 691px;
  position: relative;
  margin-left: 110px;
  font-weight: 700;
  margin-bottom: 58px;
}
.liness::before {
  content: "";
  position: absolute;
  display: block;
  width: 250px;
  border-top: 1px solid #dddddd;
  top: 20px;
}
.liness::after {
  content: "";
  position: absolute;
  display: block;
  width: 250px;
  border-top: 1px solid #dddddd;
  right: 0;
  top: 20px;
}

/* 文字 */
.pro-countent {
    padding: 15px;
}
.product-title {
    width: 208px;
    height: 40px;
    font-size: 24px;
    border-bottom: 1px solid #dddddd;
    margin-bottom: 26px;
    padding-left: 5px;
}
.pro-countent p {
    font-size: 18px;
    color: #666666;
}

/* 特点优势 */
.pro-countent {
    list-style: none;
}
.pro-countent ul {
    margin-top: 15px;
}
.pro-countent li {
    list-style: none;
    font-size: 18px; 
    margin-bottom: 20px;
    color: #666666;
}
.pro-countent span {
    display: block;
    width: 10px;
    height: 10px;
    background: #000;
    border-radius: 50%;
    float: left;
    margin-right: 13px;
    margin-top: 4px;
}
/* 视频智能处理器表格 */
.table-pro {
    text-align: center;
    color: #666666;
    font-size: 18px;
    border:1px solid #dddddd; 
	border-collapse: collapse;
}
.table-pro tr td{ 
    border:1px solid #dddddd; 
}
.table-pro tr td:nth-child(1) { 
    border: none; 
}

.table-pro .table-joup {
    border: none;
    text-decoration: underline;
    cursor: pointer;
}

/* 弹出层 */
.ivu-modal-header-inner {
    font-size: 26px;
    height: 30px;
    line-height: 30px;
    font-weight: normal;
    margin-left: 30px;
}
.ivu-modal-header {
    border: none;
}
.ivu-modal-footer {
    display: none;
}

/* 弹出层中表格 */
.table-modal {
    text-align: center;
    color: #666666;
    font-size: 18px;
    border:1px solid #dddddd; 
    border-collapse: collapse;
    margin: 0 auto;
    margin-bottom: 20px;
}
.table-modal tr td{ 
    height: 60px;
    border:1px solid #dddddd; 
}

/* 视频实时压缩服务器图片 */
.product-imges {
    padding-top: 42px;
    margin: auto;
    width: 770px;
    margin-bottom: 70px;
    overflow: hidden;
}
.product-imges img:nth-child(1) {
    width: 320px;
    height: 281px;
    float: left;
}
.product-imges img:nth-child(2) {
    width: 393px;
    float: right;
    margin-top: 100px;
}
/* 分割线 */
.lines {
  font-size: 24px;
  text-align: center;
  width: 691px;
  position: relative;
  margin-left: 110px;
  font-weight: 700;
  margin-bottom: 58px;
}
.lines::before, .lines::after  {
  content: "";
  position: absolute;
  display: block;
  width: 190px;
  border-top: 1px solid #dddddd;
  top: 20px;
}
.lines::after {
  right: 0;
  width: 190px;
}

/* 表格 */
.table-joups {
    text-decoration: underline;
    cursor: pointer;
}

/* 第四个图片 */
.product-imgess {
    width: 393px;
    height: 200px;
    padding-top: 42px;
    margin: 0 auto;
    margin-bottom: 70px;
}
/* 第六和第七个图片 */
.product-imgesss {
    width: 393px;
    height: 200px;
    padding-top: 42px;
    margin: 0 auto;
    margin-bottom: 100px;
}
.product-imgess img {
    width: 100%;
    margin-top: 50px;
}

.hide {
    display: none;
}

/* 弹出层 */
.vertical-center-modal {
    margin-bottom: 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/product/product.vue